/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProjectRoadMapInfo = {
    RDMID: string;
    NM: string;
    PRD: string;
    SUCC: ProjectRoadMapInfo.SUCC;
    DET: string;
};

export namespace ProjectRoadMapInfo {

    export enum SUCC {
        Y = 'Y',
        N = 'N',
    }


}

